'use strict'

module.exports = {
  PREFIX : 'party - ',
};
